import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Te congelas o explotas cuando tu hijo entra en crisis', 'Ya probaste hablar, castigar, ignorar o premiar y nada funciona', 'Sospechas sensibilidad alta, TDAH o sobrecarga sensorial', 'Quieres intervenir con más calma sin sentirte mala madre', 'Necesitas saber exactamente qué hacer en el momento real'];
  return <section className="bg-white py-4 md:py-24 px-5" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="bg-[#F0F4EC] rounded-3xl p-6 md:p-10 border border-[#4A6741]/20 shadow-sm" data-id="element-3">
          <h2 className="text-2xl md:text-3xl font-bold text-[#4A6741] mb-6 md:mb-8 text-center" data-id="element-4">
            Este protocolo es para ti si…
          </h2>
          <ul className="space-y-4 md:space-y-5" data-id="element-5">
            {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-3 bg-white/50 p-3 md:p-4 rounded-xl border border-[#4A6741]/10" data-id="element-6">
                <CheckCircle2 className="w-6 h-6 text-[#4A6741] flex-shrink-0 mt-0.5" data-id="element-7" />
                <span className="text-base md:text-lg text-[#2D1F0E] font-medium leading-snug" data-id="element-8">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}